<template>
  <div class="liming single-step">
    <new-liming-material
      v-if="openModal"
      @close="toggleModal"
      @selectMaterial="selectMaterial"
    />
    <div class="heading">
      <!-- <h2>{{ $ml.get('Liming') }}</h2> -->
      <h2>
        {{ $ml.get(`Liming`) }}
      </h2>
    </div>
    <form @submit="submit($event)">

      <div class="row">
        <app-text-input
          v-model="liming.CurrentPh"
          type="number"
          :min="min"
          max="14"
          :max="liming.TargetPh"
          :label="$ml.get('Current pH')"
          required
          @input="calcExcAcidity"
        />
        <app-text-input
          v-model="liming.TargetPh"
          type="number"
          :min="min"
          :max="14"
          :label="$ml.get('Target pH')"
          required
          @input="calcExcAcidity"
        />
        <app-text-input
          v-model="liming.BufferPh"
          type="number"
          :min="min"
          :max="14"
          :label="$ml.get('Buffer pH')"
          :disabled="!liming.IsNeedCalcEA"
          :required="!!liming.IsNeedCalcEA"
          @input="calcExcAcidity"
        />

      </div>
      <p v-if="liming.CurrentPh > liming.TargetPh" style="color:red;">{{ $ml.get('Current pH cannot be more then Target pH') }}</p>

      <div class="row">
        <app-text-input
          v-model="liming.ExcAcidity"
          type="number"
          :min="min"
          :max="100"
          :label="$ml.get('Exchangeable Acidity')"
          :disabled="!!liming.IsNeedCalcEA"
          :required="!liming.IsNeedCalcEA"
        />
        <app-checkbox
          @input="calcExcAcidity"
          v-model="liming.IsNeedCalcEA"
          :label="$ml.get('Calculate automatically')"
          :info-tip="$ml.get('Tick the box to calculate automatically the Exchangeable Acidity which refers to the amount of acid cations, aluminium and hydrogen, occupied on the Cation Exchange Capacity')"
        />
      </div>

      <div class="row">
        <app-sel
          :click="onChange()"
          v-model="liming.materialId"
          :items="materials"
          key-name="id"
          label-name="MaterialName"
          :label="$ml.get(`Material`)"
        >
          <template v-slot="{ items }">
            <app-sel-opt
              v-for="item in items"
              :value="item"
              :key="item.id"
            >
              {{ item.MaterialName }}
            </app-sel-opt>
          </template>
        </app-sel>
        <app-btn @click="toggleModal">{{ $ml.get('Create new material') }}</app-btn>
      </div>
      <div class="material-info" v-if="selectedMaterialInfo">
        <p>
          {{ $ml.get('CCE') }}:
          <b>{{ selectedMaterialInfo.CCE }}%</b>
        </p>
        <p>
          {{ $ml.get('Ca') }}:
          <b>{{ selectedMaterialInfo.CaPer }}%</b>
        </p>
        <p>
          {{ $ml.get('Mg') }}:
          <b>{{ selectedMaterialInfo.MgPer }}%</b>
        </p>
        <p>
          {{ $ml.get('ENV') }}:
          <b>{{ selectedMaterialInfo.ENV }}%</b>
        </p>
        <p>
          {{ $ml.get('Moisture') }}:
          <b>{{ selectedMaterialInfo.Moisture }}%</b>
        </p>
        <p>
          {{ $ml.get('Pass60') }}:
          <b>{{ selectedMaterialInfo.Pass60 }}%</b>
        </p>
        <p>
          {{ $ml.get('Pass6to80') }}:
          <b>{{ selectedMaterialInfo.Pass6to80 }}%</b>
        </p>

      </div>

      <div class="row">
        <app-text-input
          v-model="liming.MonthsSinceLastApp"
          :label="$ml.get('Months from last application')"
          type="number"
          :min="min"
          max="80"
          :hint="$ml.get('months')"
          required
        />
        <app-text-input
          v-model="liming.AmountLastApp"
          :label="$ml.get('Amount last application')"
          type="number"
          :hint="$ml.get('t/ha')"
          required
        />
      </div>

      <div class="row">
        <app-text-input
          v-model="liming.OM"
          :label="$ml.get('Organic matter (OM)')"
          type="number"
          :hint="$ml.get('%')"
          required
        />
        <app-text-input
          v-model="liming.BulkDensity"
          :label="$ml.get('Bulk density')"
          type="number"
          :min="min"
          :hint="$ml.get('g/cm3')"
          required
        />
        <app-text-input
          v-model="liming.PlowDepth"
          :label="$ml.get('Layer Depth')"
          type="number"
          :min="min"
          :max="1000"
          hint="cm_inch"
          required
        />
      </div>

      <div class="calculate-row">
        <app-btn :disabled="disabled" type="submit">
          {{ $ml.get('Calculate') }}
        </app-btn>

        <div class="env-error" v-if="selectedMaterialInfo && showEnvMsg">
          {{$ml.get('ENV value out of the range')}}
        </div>
      </div>



    </form>

    <div class="results" v-if="liming.result">
      <p class="result">
        {{ $ml.get('Lime requirement') }} : <b>
          <!-- {{ (liming.result.LimingAdjustModel.LimeRequirement).toFixed(2) }}
          {{ $ml.get('tons') }} -->

          {{$store.getters['unit/convert']('T', liming.result.LimingAdjustModel.LimeRequirement)}}
          {{$store.getters['unit/getLabel']('T')}}
        </b>
      </p>
      <p class="result">
        {{ $ml.get('Material to apply') }} : <b>
          <!-- {{ (liming.result.LimingAdjustModel.MaterialToApplay).toFixed(2) }}
          {{ $ml.get('tons') }} -->

          {{$store.getters['unit/convert']('T', liming.result.LimingAdjustModel.MaterialToApplay)}}
          {{$store.getters['unit/getLabel']('T')}}
        </b>
      </p>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import API from '@/api'
import NewLimingMaterial from '@/components/program/program-steps/liming/NewLimingMaterial'

export default {
  data() {
    return {
      openModal: false,
      disabled: true,
      showEnvMsg: true,
      liming: {
        materialId: null,
        IsNeedCalcEA: false,
        CurrentPh: null, //coming from soil test
        TargetPh: null,
        BufferPh: null,
        ExcAcidity: null,
        MonthsSinceLastApp: null,
        AmountLastApp: null,
        OM: null, // coming from soil test
        BulkDensity: null, // coming from soil test
        PlowDepth: null, // coming from soil test
      },
      materials: {},
    }
  },
  props: {
    min: {
      type: Number,
      default: 0
    }
  },
  methods: {
    onChange() {
      if(this.selectedMaterialInfo) {
        this.disabled = this.selectedMaterialInfo.ENV <= 0 ? true : false
        this.showEnvMsg = this.selectedMaterialInfo.ENV <= 0 ? true : false
      }
    },
    calcExcAcidity() {
      if(this.liming.IsNeedCalcEA) {
        if (this.liming.CurrentPh <= 0 || this.liming.BufferPh <= 0 || this.liming.TargetPh <= 0) {
          this.liming.ExcAcidity = 0;
        } else {
          if (this.liming.TargetPh < 6.5) {
          this.liming.ExcAcidity = 39.3 - 3.69 * this.liming.CurrentPh - 2.83 * this.liming.BufferPh;
        } else if (this.liming.TargetPh >= 7) {
          this.liming.ExcAcidity = 62.6 - 2.33 * this.liming.CurrentPh - 7.13 * this.liming.BufferPh;
        } else {
          this.liming.ExcAcidity = 51.8 - 2.77 * this.liming.CurrentPh - 5.38 * this.liming.BufferPh;
        }
        this.liming.ExcAcidity = this.liming.ExcAcidity < 0 ? 0 : this.liming.ExcAcidity;
        }
      }
      this.liming.ExcAcidity = (this.liming.ExcAcidity).toFixed(2);
    },
    submit(e) {
      e.preventDefault();
      this.calculateLiming();
    },
    toggleModal() {
      this.openModal ^= true;
    },
    loadMaterials(val = null) {
      console.log('text')
      return API.program.getLimingMaterials()
        .then(res => {
          this.materials = res.data.data;
          if(val) {
            this.liming.materialId = val;
          }
        })
    },
    selectMaterial(val) {
      this.loadMaterials(val);
    },
    finish(obj) {
      if(obj) {
        // console.log(obj);
        this.liming = obj;
        this.$store.dispatch('program/steps/setCurrentStep', 'liming');
        this.$store.dispatch('program/canGoToNextStep', true);
      }
    },
    drop() {
      this.$store.dispatch('program/steps/setCurrentStep', 'tests')
      this.$store.dispatch('program/canGoToNextStep', false);
    },
    getLimingResult() {
      return API.program.getLimingResult(this.program.id)
        .then(res => {
          this.finish(res.data.data);
        })
        .catch(err => {
          this.drop();
        });;
    },
    calculateLiming() {
      return API.program.calculateLiming(this.liming, this.program.id)
        .then(res => {
          this.finish(res.data.data);
        })
        .catch(err => {
          this.drop();
        });
    },
    soilTestCheck() {
      let soilTestId = this.program.soilTestId;
      if(soilTestId) {
        return API.SoilTestAPI.get(soilTestId)
          .then(res => {
            let test = res.data;
            this.liming.PlowDepth = test.layer_depth;
            this.liming.BulkDensity = test.bulk;
            this.liming.OM = test.om;
            this.liming.CurrentPh = test.ph;
          })
      }
    },
  },
  destroyed() {
    this.$store.dispatch('program/canGoToNextStep', true);
  },
  async created() {
    await this.loadMaterials();
    await this.soilTestCheck();
    await this.getLimingResult();
    // this.$store.dispatch('program/canGoToNextStep', false);
    // this.$store.dispatch('program/steps/goToNextStep');
    // this.$store.dispatch('program/steps/setCurrentStep', 'liming');

  },
  components: {
    NewLimingMaterial,
  },
  computed: {
    ...mapGetters({
      program: 'program/data',
    }),
    selectedMaterialInfo() {
      if(this.materials.length && this.liming.materialId) {
        return this.materials.find(x => x.id == this.liming.materialId);
      } else {
        return null;
      }
    },
  },

}
</script>

<style lang="scss" scoped>
.liming {
  .material-info {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    margin: 0 0 24px;
    p {
      margin: 0;
      margin-right: 16px;
    }
  }
  form {
    .row {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      margin-right: -16px;
      margin-left: -16px;
      margin-bottom: 24px;
      > div, > button {
        margin-top: 16px;
        flex-basis: calc(33.33% - 32px);
        margin-right: 16px;
        margin-left: 16px;
      }
    }
  }
  .results {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    // justify-content: space-between;
    .result {
      font-size: 18px;
      margin-right: 24px;
      display: flex;
      flex-direction: column;
      b {
        font-size: 22px;
        padding-top: 4px;
      }
    }
  }
}
</style>
